module.exports = __webpack_public_path__ + "img/Barbarian.e771a64f.png";